import Layout from '@/components/Layout'
export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '业财一体化移动办公'
    },
    component: () => import('@/pages/login')
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        name: 'vehicleRegistration',
        path: '/vehicleRegistration',
        meta: {
          title: '登记机动车'
        },
        component: () => import('@/pages/vehicleRegistration')
      }, {
        name: 'foundApproval',
        path: '/foundApproval',
        meta: {
          title: '银行付款审批队列',
          keepAlive: true
        },
        component: () => import('@/pages/foundApproval')
      }, {
        name: 'foundDetail',
        path: '/foundDetail',
        meta: {
          title: '银行付款审批明细'
        },
        component: () => import('@/pages/foundDetail')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js